import React, { useState, useEffect } from "react";
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import userService from "../services/userService";

const styles = {
  header: {
    height: 56,
    display: "flex",
    alignItems: "center",
     //background: "linear-gradient(90deg, #6B46C1, #D53F8C 70%)",
    background: "#eeeef3ff", // Deep Indigo
    color: "#eee",
    padding: "0 28px",
    //borderTopRightRadius: 20,
    //borderTopLeftRadius: 20,
    gap: 12,
    minWidth: 0,
    position: "sticky",
    top: 0,
    zIndex: 101,
    userSelect: "none",
  },
  avatar: {
    width: 36,
    height: 36,
    fontWeight: 700,
    borderRadius: "50%",
    background: "linear-gradient(135deg,#8b5cf6,#4f46e5)",
    color: "#fff",
    fontSize: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  username: {
    fontWeight: 600,
    fontSize: 16,
    color: "#4338ca",
  },
  toggleBtn: {
    border: "1px solid rgba(99, 102, 241, 0.2)",
    background: "rgba(255, 255, 255, 0.9)",
    color: "#6366f1",
    fontSize: 24,
    width: 40,
    height: 40,
    borderRadius: "8px",
    cursor: "pointer",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 12,
    transition: "all 0.2s ease",
    position: "relative",
    zIndex: 102,
    pointerEvents: "auto",
    boxShadow: "0 2px 4px rgba(99, 102, 241, 0.1)",
  },
  toggleBtnHover: {
    background: "#6366f1",
    color: "#fff",
    boxShadow: "0 4px 8px rgba(99, 102, 241, 0.3)",
    transform: "scale(1.05)",
  },
  right: {
    marginLeft: "auto",
  },
  logout: {
    background: "#6366f1",
    color: "#f9fafb",
    fontWeight: 600,
    border: "none",
    borderRadius: "0.75rem",
    padding: "8px 22px",
    fontSize: "1rem",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgb(99 102 241 / 0.5)",
    userSelect: "none",
    transition: "background 0.2s",
  },
};

export default function UserHeader({ sidebarOpen, setSidebarOpen, isMobile = false }) {
  const [userName, setUserName] = useState("User");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await userService.getUserDashboard();
        if (response.success && response.data?.user?.first_name) {
          setUserName(response.data.user.first_name);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        // Keep default "User" if fetch fails
      }
    };

    fetchUserData();
  }, []);

  function handleLogout() {
    localStorage.removeItem("authToken");
    navigate("/");
  }

  return (
    <header 
      className="user-header"
      style={{
        ...styles.header,
        padding: isMobile ? "0 15px" : "0 28px",
        height: isMobile ? 50 : 56,
      }}
    >
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        gap: 12, 
        flex: 1, 
        minWidth: 0,
        position: "relative",
        zIndex: 102,
        pointerEvents: "auto"
      }}>
        <div style={styles.avatar} aria-label="User initial">
          {userName.charAt(0).toUpperCase()}
        </div>
        {!isMobile && <span style={styles.username}>{userName}</span>}
        {/* Sidebar toggle next to username */}
        <button
          type="button"
          style={styles.toggleBtn}
          aria-label={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setSidebarOpen((prev) => !prev);
          }}
          title={sidebarOpen ? "Collapse sidebar" : "Expand sidebar"}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = styles.toggleBtnHover.background;
            e.currentTarget.style.color = styles.toggleBtnHover.color;
            e.currentTarget.style.boxShadow = styles.toggleBtnHover.boxShadow;
            e.currentTarget.style.transform = styles.toggleBtnHover.transform;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = styles.toggleBtn.background;
            e.currentTarget.style.color = styles.toggleBtn.color;
            e.currentTarget.style.boxShadow = styles.toggleBtn.boxShadow;
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          {sidebarOpen ? <AiOutlineMenuFold /> : <AiOutlineMenuUnfold />}
        </button>
      </div>

      <div style={styles.right}>
        <button 
          style={{
            ...styles.logout,
            padding: isMobile ? "6px 15px" : "8px 22px",
            fontSize: isMobile ? "0.9rem" : "1rem",
          }} 
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </header>
  );
}
